const UploadFileToUrl = async (url, file, fileType) => {
  let contentType;
  if (fileType === 'csv') {
    contentType = 'text/csv';
  } else if (fileType === 'xlsx') {
    contentType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  } else if (fileType === 'xls') {
    contentType = 'application/vnd.ms-excel';
  } else if (fileType === 'png') {
    contentType = 'image/png';
  } else if (fileType === 'jpg' || fileType === 'jpeg') {
    contentType = 'image/jpeg';
  } else {
    throw new Error('Unsupported file type');
  }
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': contentType,
    },
    body: file,
  };
  const response = await fetch(url, options);
  return response;
};

export default UploadFileToUrl;
